import React from "react";

const Bigtitle = ( {data} ) =>{
    return(
        <span className="font-medium md:text-[32px] text-[24px] lg:mt-6 md:mt-8 mt-8 leading-tight" style={{color: data.color}}>{data.text}</span>
    );
};
export default Bigtitle;